export const downloadFile = (data) => {
    const url = URL.createObjectURL(data.file);
    const link = document.createElement("a");
    link.style.display = "none";
    link.href = url;
    link.download = data.name;
    document.body.appendChild(link);
    link.click();
    setTimeout(() => {
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    }, 100);
};
